import { getBooleanOperatorValuesForCollectionFilter } from '../../../services/filtering/collection-filter-mapping-service';
import { dateFilterOperators } from '../../../containers/base-filter-bar-container/reference-data-criteria-arguments';
import moment from 'moment';

const apiDateFormat = 'YYYY-MM-DD';

const genericFilterToApiFilters = ({ filterValue, criterionOperatorValue, criterionArgumentValue }) => {
  const value = Array.isArray(criterionArgumentValue) ? criterionArgumentValue.join(';') : criterionArgumentValue;
  return [
    {
      column: filterValue,
      operator: criterionOperatorValue,
      value,
    },
  ];
};

const sanitizeStringValues = (values) => (Array.isArray(values) ? values.map((v) => v.trim()) : values);

export const mapNumericFilterToApiFilters = genericFilterToApiFilters;

export const mapStringFilterToApiFilters = (filter) => {
  const sanitizedFilter = {
    ...filter,
    criterionArgumentValue: sanitizeStringValues(filter.criterionArgumentValue),
  };
  return genericFilterToApiFilters(sanitizedFilter);
};

const appliedDateFilterOperatorsToApiFilterOperators = {
  [dateFilterOperators.dateToday]: (appliedFilter) => {
    return [
      {
        column: appliedFilter.filterValue,
        operator: 'CurrentDate',
      },
    ];
  },
  [dateFilterOperators.dateYesterday]: (appliedFilter) => {
    return [
      {
        column: appliedFilter.filterValue,
        operator: 'WithinPastXDays',
        value: '1',
      },
    ];
  },
  [dateFilterOperators.dateLastWeek]: (appliedFilter) => {
    return [
      {
        column: appliedFilter.filterValue,
        operator: 'WithinPastXDays',
        value: '7',
      },
    ];
  },
  [dateFilterOperators.dateLast30Days]: (appliedFilter) => {
    return [
      {
        column: appliedFilter.filterValue,
        operator: 'WithinPastXDays',
        value: '30',
      },
    ];
  },
  [dateFilterOperators.dateOnOrBefore]: (appliedFilter) => {
    return [
      {
        column: appliedFilter.filterValue,
        operator: 'OnOrBefore',
        value: moment(appliedFilter.criterionArgumentValue).format(apiDateFormat),
      },
    ];
  },
  [dateFilterOperators.dateOnOrAfter]: (appliedFilter) => {
    return [
      {
        column: appliedFilter.filterValue,
        operator: 'OnOrAfter',
        value: moment(appliedFilter.criterionArgumentValue).format(apiDateFormat),
      },
    ];
  },
  [dateFilterOperators.dateThisMonth]: (appliedFilter) => {
    return [
      {
        column: appliedFilter.filterValue,
        operator: 'OnOrAfter',
        value: moment().startOf('month').startOf('day').format(apiDateFormat),
      },
      {
        column: appliedFilter.filterValue,
        operator: 'OnOrBefore',
        value: moment().endOf('month').startOf('day').format(apiDateFormat),
      },
    ];
  },
  [dateFilterOperators.dateLastMonth]: (appliedFilter) => {
    return [
      {
        column: appliedFilter.filterValue,
        operator: 'OnOrAfter',
        value: moment().subtract('month', 1).startOf('month').startOf('day').format(apiDateFormat),
      },
      {
        column: appliedFilter.filterValue,
        operator: 'OnOrBefore',
        value: moment().subtract('month', 1).endOf('month').startOf('day').format(apiDateFormat),
      },
    ];
  },
  [dateFilterOperators.dateCustomRange]: (appliedFilter) => {
    return [
      {
        column: appliedFilter.filterValue,
        operator: 'OnOrAfter',
        value: moment(appliedFilter.criterionArgumentValue.startRangeDate).format(apiDateFormat),
      },
      {
        column: appliedFilter.filterValue,
        operator: 'OnOrBefore',
        value: moment(appliedFilter.criterionArgumentValue.endRangeDate).format(apiDateFormat),
      },
    ];
  },
  [dateFilterOperators.dateWithinThePastXDays]: (appliedFilter) => {
    return [
      {
        column: appliedFilter.filterValue,
        operator: 'WithinPastXDays',
        value: appliedFilter.criterionArgumentValue,
      },
    ];
  },
  [dateFilterOperators.dateWithinTheNextXDays]: (appliedFilter) => {
    return [
      {
        column: appliedFilter.filterValue,
        operator: 'WithinNextXDays',
        value: appliedFilter.criterionArgumentValue,
      },
    ];
  },
  [dateFilterOperators.dateXDaysAgoOrMore]: (appliedFilter) => {
    return [
      {
        column: appliedFilter.filterValue,
        operator: 'BeforeXDays',
        value: appliedFilter.criterionArgumentValue,
      },
    ];
  },
  [dateFilterOperators.dateXDaysAheadOrMore]: (appliedFilter) => {
    return [
      {
        column: appliedFilter.filterValue,
        operator: 'AfterXDays',
        value: appliedFilter.criterionArgumentValue,
      },
    ];
  },
};
export const mapDateTimeFilterToApiFilters = (appliedFilter) => {
  return appliedDateFilterOperatorsToApiFilterOperators[appliedFilter.criterionOperatorValue](appliedFilter);
};

export const mapCollectionFilterToApiFilters = (appliedFilter) => {
  const criteria = getBooleanOperatorValuesForCollectionFilter(appliedFilter);
  return [
    {
      column: appliedFilter.filterValue,
      values: [appliedFilter.criterionArgumentValue],
      isIn: criteria.isIn,
      isNull: criteria.isNull,
    },
  ];
};
